import { SdgAlignmentValence } from '@upright/common/model/output/scores/sdg-alignment/types';
import { getMostAlignedSdgs } from '@upright/common/model/output/scores/sdg-alignment/utils';
import { GenericDynamicHeightInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/generic-dynamic-height-info-box';
import { InfoBoxTitleRow } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-title-row';
import { commonInfoBoxPadding } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { toBounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/utils';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { useSdgLensContext } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/use-sdg-lens-context';
import styled from 'styled-components';

export function NoMisalignmentBox() {
  const ctx = useSdgLensContext();
  const baseLayout = useCarouselLayout();
  const data = ctx?.data.sdgAlignments;
  if (!data) {
    return <></>;
  }
  const fullWidth = baseLayout.fullArea().width;
  if (fullWidth < 450) {
    return <></>;
  }
  const sdgIds = getMostAlignedSdgs(data, SdgAlignmentValence.MISALIGNED, false);
  const dataArea = baseLayout.dataArea(Side.LEFT);
  if (sdgIds.length > 0) {
    return <></>;
  }
  const width = Math.min(dataArea.width - 20 * 2, 300);
  const refArea = toBounds({
    x1: dataArea.cx - width / 2,
    x2: dataArea.cx + width / 2,
    y1: dataArea.y1,
    y2: dataArea.y2,
  });

  return (
    <GenericDynamicHeightInfoBox refArea={refArea} side={Side.LEFT}>
      <Wrap>
        <InfoBoxTitleRow>
          <div>No misalignment found</div>
        </InfoBoxTitleRow>
        <Main>
          <p>No misalignment with any of the UN Sustainable Development Goals was found.</p>
          {fullWidth > 550 && (
            <p>
              Overall, the SDGs have been created from a goal-oriented standpoint, focusing on what should be achieved
              rather than what should be avoided. For this reason, the SDG data represents positive impacts more
              comprehensively than negative ones. For a more comprehensive perspective to both positive and negative
              impacts, we recommend referring to Upright's net impact data in favor of the SDGs.
            </p>
          )}
        </Main>
      </Wrap>
    </GenericDynamicHeightInfoBox>
  );
}

const Wrap = styled.div``;

const Main = styled.div`
  ${commonInfoBoxPadding};
  line-height: 1.25;
  p + p {
    margin-top: 1em;
  }
  text-align: left;
`;
